import { render } from "./CreateTransfer.vue?vue&type=template&id=63770fd5&scoped=true"
import script from "./CreateTransfer.vue?vue&type=script&lang=js"
export * from "./CreateTransfer.vue?vue&type=script&lang=js"

import "./CreateTransfer.vue?vue&type=style&index=0&id=63770fd5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63770fd5"]])

export default __exports__